import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FirmasPendientesAvanceComponent } from './firmas-pendientes-avance/firmas-pendientes-avance.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'firmas-pendientes-avances',
        component: FirmasPendientesAvanceComponent,
        data: {
          title: "Firmas pendientes / Avance",
          breadcrumb: "Firmas pendientes / Avance"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FirmasPendientesAvanceRoutingModule { }
